export default __webpack_public_path__ + "static/media/signal_1.32d067b3.mp3";